/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/histogram_quantile.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the φ-quantile of a classic histogram represented by cumulative `le` buckets or a native (exponential) histogram.
 *
 * @example
 * histogram_quantile(0.9, rate(http_request_duration_seconds_bucket[5m]))
 */
const definition: PromqlFunctionDefinition = {
  type: 'histogram',
  name: 'histogram_quantile',
  signatures: [
    {
      params: [
        {
          name: 'φ',
          type: 'scalar',
          optional: false,
          description: 'Quantile value (0 ≤ φ ≤ 1).',
        },
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
